import React from 'react';
import { Link } from 'react-router-dom';
import { LocationDescriptorObject } from 'history';
import './breadCrumb.module.scss';
import { V3Routes } from '../../routes';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';

type CrumbItemProps = {
  to?: LocationDescriptorObject;
  text: string;
};

const CrumbItem = ({ to, text }: CrumbItemProps) => {
  let displayText = GlobalStatesV3.viewport.isDesktop ? text : text.length > 13 ? text.slice(0, 12) + '…' : text;
  if (to) {
    displayText = GlobalStatesV3.viewport.isDesktop ? text : text.length > 7 ? text.slice(0, 6) + '…' : text;
    return (
      <li styleName="breadcrumb-item">
        <Link to={to}>{displayText}</Link>
      </li>
    );
  }
  return <li styleName="breadcrumb-item">{displayText}</li>;
};

type BreadCrumbProps = {
  items: CrumbItemProps[];
  hasHome?: boolean;
};

export const BreadCrumb = ({ items, hasHome }: BreadCrumbProps) => {
  const homeItem = { text: 'ホーム', to: V3Routes.home() };
  const breadCrumbItems = hasHome ? [homeItem, ...items] : items;
  return (
    <>
      <ul styleName="breadcrumb">
        {breadCrumbItems.map((item, index) => {
          return <CrumbItem key={index} to={item.to} text={item.text} />;
        })}
      </ul>
    </>
  );
};
